import { render, staticRenderFns } from "./layout-seo-blocks.vue?vue&type=template&id=58617965&scoped=true"
import script from "./layout-seo-blocks.vue?vue&type=script&lang=js"
export * from "./layout-seo-blocks.vue?vue&type=script&lang=js"
import style0 from "./layout-seo-blocks.vue?vue&type=style&index=0&id=58617965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58617965",
  null
  
)

export default component.exports